package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.String

public class SettingsQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun getSetting(key: String): Query<String> = GetSettingQuery(key) { cursor ->
    cursor.getString(0)!!
  }

  public suspend fun insertSetting(key: String, value_: String) {
    driver.execute(-36_607_713,
        """INSERT OR REPLACE INTO SettingsEntity(key, value) VALUES (?, ?)""", 2) {
          bindString(0, key)
          bindString(1, value_)
        }.await()
    notifyQueries(-36_607_713) { emit ->
      emit("SettingsEntity")
    }
  }

  private inner class GetSettingQuery<out T : Any>(
    public val key: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("SettingsEntity", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("SettingsEntity", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_848_031_406, """SELECT value FROM SettingsEntity WHERE key = ?""",
        mapper, 1) {
      bindString(0, key)
    }

    override fun toString(): String = "Settings.sq:getSetting"
  }
}
